app.filter('age', function () {
    return function (birthday) {

        if (typeof birthday != "undefined") {
            var parts = birthday.split("-");
            birthday = new Date(parts[0], parts[1], parts[2]);
            var ageDifMs = Date.now() - birthday.getTime();
            var ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        } else {
            return birthday;
        }
    };
});


app.filter('_datenull', function () {
    return function (value, format, blank) {        
        if (_.isUndefined(format))
            format = 'DD.MM.YYYY';
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
            return moment(value).format(format);
        } else {
            return blank;
        }
    };
});